import type { ChangeEvent, FC } from 'react';

type CheckboxPropTypes = {
  label?: string;
  name: string;
  id?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
};

const Checkbox: FC<CheckboxPropTypes> = ({ checked, name, id, label, onChange }) => {
  return (
    <div className="flex items-center gap-3 py-[5px]">
      <input
        onChange={onChange}
        checked={checked}
        name={id || name}
        id={id || name}
        type="checkbox"
        className="appearance-none flex-shrink-0 checked:bg-checked-icon w-[14px] h-[14px] md:w-4 md:h-4 bg-center bg-no-repeat bg-contain checked:border-none rounded-[1px] border-sz-blue-100 border-2 cursor-pointer hover:bg-sz-blue-100/10"
      />
      <label
        className="text-[13px] md:text-base font-normal text-sz-black leading-4 md:leading-5"
        htmlFor={id || name}
      >
        {label}
      </label>
    </div>
  );
};

export { Checkbox };
